// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__pD6s_","col":"styles_col__1dtu0","fulfillmentStatus":"styles_fulfillmentStatus__3gT8M","emailCol":"styles_emailCol__2R5Zj"};